var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Mixins, Prop } from 'vue-property-decorator';
import ItemsMixin from '@/mixins/items-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import FilterSidesheetMixin from '@/mixins/filter-sidesheet-mixin';
import BaseTableFilters from '@/components/base/BaseTableFilters.vue';
import ValidatedAutocomplete from '@/components/shared/ValidatedAutocomplete.vue';
// dependency-injection
import { TYPES } from '@/dependency-injection/types';
import { lazyInject } from '@/dependency-injection';
import { OpportunityService } from '@/services/opportunity-management/opportunity-service';
import { MaterialGroupService } from '@/services/material-management/material-group-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import { CarrierGroupService } from '@/services/carrier-management/carrier-group-service';
// Validation
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
// Date functions
import * as addDays from 'date-fns/add_days';
import * as format from 'date-fns/format';
var OpportunityFiltersSidesheet = /** @class */ (function (_super) {
    __extends(OpportunityFiltersSidesheet, _super);
    function OpportunityFiltersSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = {
            statuses: [],
            range: [],
            sites: [],
            materialGroups: [],
            dispatchDesks: [],
            carriers: [],
            carrierGroups: [],
            markets: [],
            platts: [],
        };
        _this.selectedFilters = {
            statuses: [],
            date: '',
            site: '',
            materialGroup: '',
            dispatchDesks: [],
            carriers: [],
            carrierGroups: [],
            market: '',
            platt: '',
        };
        _this.filtersLoaded = false;
        _this.datePicker = false;
        return _this;
    }
    OpportunityFiltersSidesheet.prototype.allowedDates = function (val) {
        var date = new Date(val);
        return date >= addDays(new Date(), -60)
            && date <= addDays(new Date(), 5);
    };
    OpportunityFiltersSidesheet.prototype.onVisible = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.getReferenceData()];
                    case 1:
                        _a.sent();
                        if (!(this.filtersLoaded === false)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.applyDefaults()];
                    case 2:
                        _a.sent();
                        this.filtersLoaded = true;
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityFiltersSidesheet.prototype.getReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var referenceDataResponse, _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: [
                                'OPPORTUNITY_STATUS',
                                'PLATTS',
                            ], includeDeleted: false })];
                    case 1:
                        referenceDataResponse = _h.sent();
                        // opportunity statuses
                        this.options.statuses = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'OPPORTUNITY_STATUS'; }).sort(function (a, b) {
                                if (a.code > b.code) {
                                    return 1;
                                }
                                if (a.code < b.code) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        // date
                        _a = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/opportunityreport/getdaterange')];
                    case 2:
                        // date
                        _a.range = _h.sent();
                        // material groups
                        _b = this.options;
                        return [4 /*yield*/, this.materialGroupService.getAllRef(true)];
                    case 3:
                        // material groups
                        _b.materialGroups = (_h.sent()).data;
                        // sites
                        _c = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/site/getsites')];
                    case 4:
                        // sites
                        _c.sites = _h.sent();
                        // markets
                        _d = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/site/getmarkets')];
                    case 5:
                        // markets
                        _d.markets = _h.sent();
                        // dispatch desks
                        _e = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getdispatchdesks')];
                    case 6:
                        // dispatch desks
                        _e.dispatchDesks = _h.sent();
                        // carriers
                        _f = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getcarriers')];
                    case 7:
                        // carriers
                        _f.carriers = _h.sent();
                        // carriers groups
                        _g = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getcarriergroups')];
                    case 8:
                        // carriers groups
                        _g.carrierGroups = _h.sent();
                        // platts
                        this.options.platts = referenceDataResponse.success
                            ? referenceDataResponse.data.filter(function (item) { return item.module === 'PLATTS'; }).sort(function (a, b) {
                                if (a.code > b.code) {
                                    return 1;
                                }
                                if (a.code < b.code) {
                                    return -1;
                                }
                                return 0;
                            })
                            : [];
                        // add ALL option to platts
                        this.options.platts.unshift({ shortDescription: 'ALL', code: null });
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityFiltersSidesheet.prototype.applyDefaults = function () {
        return __awaiter(this, void 0, void 0, function () {
            var defaultFilters, daysToAdd, desk, carrier, carrierGroup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userPreferenceService.getFiltersByModule('OPPORTUNITY_LOADS')];
                    case 1:
                        defaultFilters = _a.sent();
                        daysToAdd = this.userPreferenceService.getValueForComponent(defaultFilters, 'DATE');
                        desk = this.userPreferenceService.getValueForComponent(defaultFilters, 'DISPATCH_DESK');
                        carrier = this.userPreferenceService.getValueForComponent(defaultFilters, 'CARRIER');
                        carrierGroup = this.userPreferenceService.getValueForComponent(defaultFilters, 'CARRIER_GROUP');
                        this.selectedFilters.dispatchDesks = desk && desk !== 'ALL' ? [desk] : [];
                        this.selectedFilters.carriers = carrier ? [carrier] : [];
                        this.selectedFilters.carrierGroups = carrierGroup ? [carrierGroup] : [];
                        this.selectedFilters.site = this.userPreferenceService.getValueForComponent(defaultFilters, 'SITE');
                        this.selectedFilters.date = format(addDays(new Date(), +daysToAdd), 'YYYY-MM-DD');
                        this.selectedFilters.statuses = this.userPreferenceService.getValueForComponent(defaultFilters, 'OPPORTUNITY_STATUS').split('|');
                        this.selectedFilters.materialGroup = this.userPreferenceService.getValueForComponent(defaultFilters, 'MATERIAL_GROUP');
                        this.selectedFilters.market = this.userPreferenceService.getValueForComponent(defaultFilters, 'MARKET');
                        this.selectedFilters.platt = this.userPreferenceService.getValueForComponent(defaultFilters, 'PLATTS');
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityFiltersSidesheet.prototype.filterOpportunities = function () {
        return __awaiter(this, void 0, Promise, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.opportunityService.getAllByRequest({
                                site: this.selectedFilters.site,
                                date: this.selectedFilters.date,
                                statuses: this.selectedFilters.statuses,
                                materialGroup: this.selectedFilters.materialGroup,
                                dispatchDesks: this.selectedFilters.dispatchDesks,
                                carriers: this.selectedFilters.carriers,
                                carrierGroups: this.selectedFilters.carrierGroups,
                                market: (this.selectedFilters.market === 'ALL' ? null : this.selectedFilters.market),
                                platt: this.selectedFilters.platt,
                            }, 'getopportunityloads')];
                    case 1:
                        data = _a.sent();
                        this.$emit('filtered', this.selectedFilters.date);
                        if (data.success === false) {
                            this.showSnackbar({ text: data.message, color: 'error' });
                            return [2 /*return*/, []];
                        }
                        else {
                            this.items = data.data;
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        this.showSnackbar({ text: 'Unable to get opportunity loads', color: 'error' });
                        console.error(error_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        this.close();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OpportunityFiltersSidesheet.prototype.handleCarrierGroupUpdated = function (selectedCarrierGroupIds) {
        this.filterSelectedCarriersByGroupIds(selectedCarrierGroupIds);
        this.filterSelectedDesksByCarrierIds(this.selectedFilters.carriers);
    };
    OpportunityFiltersSidesheet.prototype.handleCarrierUpdated = function (selectedCarrierIds) {
        this.filterSelectedDesksByCarrierIds(selectedCarrierIds);
    };
    OpportunityFiltersSidesheet.prototype.filterSelectedCarriersByGroupIds = function (groupIds) {
        // get ids of carriers with selected groups
        var carrierIdsWithSelectedGroup = this.options.carriers
            .filter(function (item) {
            return groupIds.includes(item.groupId);
        })
            .map(function (item) { return item.id; });
        // filter out selected carriers based on if they belong to group
        this.selectedFilters.carriers = this.selectedFilters.carriers
            .filter(function (id) {
            return carrierIdsWithSelectedGroup.includes(id);
        });
    };
    OpportunityFiltersSidesheet.prototype.filterSelectedDesksByCarrierIds = function (carrierIds) {
        // get ids of desks with selected parents
        var dispatchDeskIdsWithSelectedParents = this.options.dispatchDesks
            .filter(function (item) {
            return carrierIds.includes(item.parentId);
        })
            .map(function (item) { return item.id; });
        // filter out selected desks based on if they belong to parent
        this.selectedFilters.dispatchDesks = this.selectedFilters.dispatchDesks
            .filter(function (id) {
            return dispatchDeskIdsWithSelectedParents.includes(id);
        });
    };
    Object.defineProperty(OpportunityFiltersSidesheet.prototype, "formattedDate", {
        get: function () {
            return format(this.selectedFilters.date, 'MM/DD/YYYY');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityFiltersSidesheet.prototype, "filteredCarriers", {
        get: function () {
            var _this = this;
            if (this.selectedFilters.carrierGroups.length === 0) {
                return this.options.carriers || [];
            }
            else {
                return (this.options.carriers || [])
                    .filter(function (item) {
                    return _this.selectedFilters.carrierGroups.includes(item.groupId);
                });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityFiltersSidesheet.prototype, "filteredDesks", {
        get: function () {
            var _this = this;
            if (this.selectedFilters.carriers.length === 0) {
                return this.options.dispatchDesks || [];
            }
            else {
                return (this.options.dispatchDesks || [])
                    .filter(function (item) {
                    return _this.selectedFilters.carriers.includes(item.parentId);
                });
            }
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d;
    __decorate([
        lazyInject(TYPES.OpportunityService),
        __metadata("design:type", typeof (_a = typeof OpportunityService !== "undefined" && OpportunityService) === "function" ? _a : Object)
    ], OpportunityFiltersSidesheet.prototype, "opportunityService", void 0);
    __decorate([
        lazyInject(TYPES.MaterialGroupService),
        __metadata("design:type", typeof (_b = typeof MaterialGroupService !== "undefined" && MaterialGroupService) === "function" ? _b : Object)
    ], OpportunityFiltersSidesheet.prototype, "materialGroupService", void 0);
    __decorate([
        lazyInject(TYPES.CarrierService),
        __metadata("design:type", typeof (_c = typeof CarrierService !== "undefined" && CarrierService) === "function" ? _c : Object)
    ], OpportunityFiltersSidesheet.prototype, "carrierService", void 0);
    __decorate([
        lazyInject(TYPES.CarrierGroupService),
        __metadata("design:type", typeof (_d = typeof CarrierGroupService !== "undefined" && CarrierGroupService) === "function" ? _d : Object)
    ], OpportunityFiltersSidesheet.prototype, "carrierGroupService", void 0);
    __decorate([
        Prop({ type: Boolean, required: true }),
        __metadata("design:type", Boolean)
    ], OpportunityFiltersSidesheet.prototype, "showIndexFilter", void 0);
    OpportunityFiltersSidesheet = __decorate([
        Component({
            components: {
                'base-table-filters': BaseTableFilters,
                'validated-autocomplete': ValidatedAutocomplete,
            },
        })
    ], OpportunityFiltersSidesheet);
    return OpportunityFiltersSidesheet;
}(Mixins(ItemsMixin, SnackbarMixin, FilterSidesheetMixin)));
export default OpportunityFiltersSidesheet;
